<template>
  <v-card flat tile outlined :loading="!chart">
    <v-toolbar flat>
      <v-toolbar-title>Stato dei ticket</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col v-for="c in counters" :key="c.label" cols="12" sm="4">
          <v-card :color="c.color" dark tile elevation="0">
            <v-card-title class="text-h4">{{ c.count }}</v-card-title>
            <v-card-subtitle class="subtitle-1">{{ c.label }}</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <ChartTable label="Stato" :data="rows" />
        </v-col>
        <v-col class="text-center">
          <pie-chart
            v-if="chart"
            :messages="{ empty: 'Non ci sono dati' }"
            :data="pieData"
            :library="library"
            width="240px"
          ></pie-chart>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn-toggle v-model="interval" mandatory tile group>
        <v-btn value="3" small>
          3 mesi
        </v-btn>
        <v-btn value="6" small>
          6 mesi
        </v-btn>
        <v-btn value="12" small>
          12 mesi
        </v-btn>
      </v-btn-toggle>
    </v-card-actions>
  </v-card>
</template>

<script>
import dashboard from '@mixins/dashboard.js'
import ChartTable from '@components/dashboard/ChartTable.vue'

// ticket aperti = ACQUISITA, in gestione = IN LAVORAZIONE, gestiti = CHIUSO
const COUNTERS = [
  { label: 'Aperti', status: 'ACQUISITA', color: 'orange darken-2' },
  { label: 'In gestione', status: 'IN LAVORAZIONE', color: 'blue' },
  { label: 'Gestiti', status: 'CHIUSO', color: 'green darken-1' },
]

export default {
  name: 'TicketsByStatus',
  components: { ChartTable },
  mixins: [dashboard],
  data: () => ({
    resource: 'report',
    scope: 'tickets_per_status',
    interval: '12',
    library: {
      layout: { padding: { left: 16, right: 16, top: 0, bottom: 16 } },
      legend: { display: false, position: 'bottom' },
    },
  }),
  computed: {
    rows() {
      const total = (this.dashboardData(this.resource, this.scope) || []).reduce(
        (acc, r) => acc + r.count,
        0
      )
      return (this.dashboardData(this.resource, this.scope) || []).map((r) => ({
        ...r,
        percentage: total ? Math.round((r.count / total) * 100) : 0,
      }))
    },
    pieData() {
      return this.rows.map((r) => [r.label, r.count])
    },
    counters() {
      return COUNTERS.map((c) => ({
        ...c,
        count: (this.rows.find((r) => r.label === c.status) || {}).count || 0,
      }))
    },
  },
  watch: {
    interval: {
      immediate: true,
      handler: 'getData',
    },
  },
  methods: {
    getData() {
      this.getReportData({
        resource: this.resource,
        scope: this.scope,
        interval: this.interval,
      })
    },
  },
}
</script>
